import { render } from "./ContactMessages.vue?vue&type=template&id=2505b8e3"
import script from "./ContactMessages.vue?vue&type=script&lang=js"
export * from "./ContactMessages.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__